import api from "./api";

class MemberDataService {
  getAll(params) {
    return api.get("/members", { params });
  }

  get(id) {
    return api.get(`/members/${id}`);
  }

  create(data) {
    return api.post("/members", data);
  }

  activationlink(data) {
    return api.post("/members/activation", data);
  }

  resetlink(data) {
    // console.log(qs.stringify(data));
    // return http.post("/members/reset/sendlink", qs.stringify(data));
    return api.post("/members/reset/sendlink", data);
  }

  verifyUser(data) {
    return api.post("/members/reset/verifyuser", data);
  }

  resetpass(data) {
    return api.post("/members/resetpass", data);
  }

  update(id, data) {
    return api.put(`/members/${id}`, data);
  }

  changepass(id, data) {
    return api.put(`/members/changepass/${id}`, data);
  }

  updatePhoto(id, data) {
    return api.put(`/members/updatePhoto/${id}`, data);
  }

  updateProfile(id, data) {
    return api.put(`/members/updateProfile/${id}`, data);
  }

  // upload(id, data) {
  //   return http.put(`/members/upload/${id}`, data);
  // }

  delete(id) {
    return api.delete(`/members/${id}`);
  }

  deleteAll() {
    return api.delete(`/members`);
  }

  findByUsername(username) {
    return api.get(`/members?username=${username}`);
  }

  getAllRoles() {
    return api.get("/members/userLevel/all");
  }
}

export default new MemberDataService();
